import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Headline, Text } from '@oneaudi/unified-web-components';
import { useSelector } from 'react-redux';
import {
  TitleWrapper,
  TitleContainer,
  HeaderDescription,
  DagTitle,
  PageTitle,
} from './Header.styles';
import { selectZipCode } from '../../reducers/zipCodeReducer';

type HeaderProps = {
  isNational: boolean;
  dag?: string;
  isFiltersOpen: boolean;
};

const Header: React.FC<HeaderProps> = ({ isNational, dag, isFiltersOpen }) => {
  const { t } = useTranslation();
  const dagName = dag?.split('(')[0];

  const { market } = useSelector(selectZipCode);

  const isCaMarket = market === 'CA';

  const title = useMemo(() => {
    if (isCaMarket) return t('promo.header.titleCA');
    if (isNational) return t('promo.header.national');
    return `${dagName} ${t('promo.header.titleUS')}`;
  }, [dagName, isCaMarket, isNational, t]);

  const description = useMemo(() => {
    if (isCaMarket) return t('promo.header.descriptionCA');
    if (isNational) return t('promo.header.descriptionNational');
    return t('promo.header.description');
  }, [isCaMarket, isNational, t]);

  return (
    <TitleContainer isFiltersOpen={isFiltersOpen}>
      <TitleWrapper data-testid="header-title-wrapper">
        {!isCaMarket && <PageTitle>{t('promo.header.store')}</PageTitle>}
        <Headline
          data-testid="header-title"
          tag="h1"
          variant={{
            order: '1',
            type: 'headline',
            weight: 'bold',
          }}
        >
          {title}
        </Headline>
        <HeaderDescription>
          <Text
            data-testid="header-body"
            variant={{
              order: '1',
              style: 'normal',
            }}
          >
            {description}
          </Text>
        </HeaderDescription>
      </TitleWrapper>
    </TitleContainer>
  );
};

export default Header;
